<template>
  <v-row align="center" justify="center">
    <v-col class='col-12' align="center" justify="center">
      <v-alert border="top" colored-border type="info" elevation="2" max-width="600" v-if="!isLoggedIn">
        Для доступа в данный раздел необходимо зарегистрироваться
      </v-alert>
      <v-alert border="top" colored-border type="info" elevation="2" max-width="600" v-else>
        Недостаточно прав для доступа в данный раздел
      </v-alert>
    </v-col>
    <v-card class="pl-9 pt-10 pr-9 pb-3" width="400">
      <auth :to="to" :hash="hash"></auth>
    </v-card>
  </v-row>
</template>
<script>
import { mapGetters } from 'vuex'


export default {
  name: 'Login',

  props: {
    to: {
      type: String,
      default: null
    },
    hash: {
      type: String,
      default: null
    },
  },

  components: {
    auth: () => import(
      '@/components/core/Auth'
    )
  },

  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isAuthenticated'
    }),
  }
}

</script>
<style scoped>
</style>